// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"bc86c057","125":"a7180fc2","144":"039b793a","198":"9e9c6e28","703":"54fc9299","880":"c26571ac"}[chunkId] + ".chunk.js";
};